var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVasIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2285",
    "data-name": "Group 2285",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2902",
    "data-name": "Path 2902",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2903",
    "data-name": "Path 2903",
    d: "M21,13.242V20h1v2H2V20H3V13.242A4.5,4.5,0,0,1,1.633,7.2L4.345,2.5A1,1,0,0,1,5.211,2H18.79a1,1,0,0,1,.866.5l2.7,4.682A4.5,4.5,0,0,1,21,13.242Zm-2,.73a4.5,4.5,0,0,1-3.75-1.36,4.5,4.5,0,0,1-6.5,0A4.5,4.5,0,0,1,5,13.973V20H19V13.973ZM5.789,4,3.356,8.213a2.5,2.5,0,0,0,4.466,2.216,1,1,0,0,1,1.856,0,2.5,2.5,0,0,0,4.644,0,1,1,0,0,1,1.856,0A2.5,2.5,0,1,0,20.635,8.2L18.21,4H5.79Z",
    transform: "translate(0 0)",
    fill: "#a0a0a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVasIcon);
export default __webpack_public_path__ + "static/media/vas-icon.a53d3c7477f56851382047aa7ceab0b5.svg";
export { ForwardRef as ReactComponent };